module.exports = __webpack_public_path__ + "static/media/notification_unread_alert.09ea82ce.svg";